import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DashboardComponent } from "./dashboard.component";
import { QueueComponent } from "./queue/queue.component";
import { RunningTasksComponent } from "./running-tasks/running-tasks.component";
import { RunnersComponent } from "./runners/runners.component";
import { StatisticsComponent } from "./statistics/statistics.component";
import { ResourcesStatusComponent } from "./resources-status/resources-status.component";
import { AuthGuard } from "../services/permission/permissions.service";


const routes: Routes = [
  {
    path: "dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],

    children: [
      {
        path: "queue",
        component: QueueComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "running-tasks",
        component: RunningTasksComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "runners",
        component: RunnersComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "statistics",
        component: StatisticsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "resources-status",
        component: ResourcesStatusComponent,
        canActivate: [AuthGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule {}
